export const transferLimitFields = [
  { key: 'consignmentBalanceLimit', label: 'Consignment Balance Limit', unit: 'money', step: '0.01' },
  { key: 'agedInventoryDaysLimit', label: 'Aged Inventory Days Limit', unit: 'days', step: '1' },
  { key: 'inventoryPiecesLimit', label: 'Inventory Pieces Limit', unit: 'pieces', step: '1' },
  { key: 'sameItemsLimit', label: 'Limit Of Same Items', unit: 'pieces', step: '1' },
];

export const transferLimitDraft = (customer) => Object.fromEntries(
  transferLimitFields.map(({ key }) => [key, customer[key] ?? ''])
);

export function assessTransferLimits(customer, summary, queuedRows = [], newRows = []) {
  const quantity = (row) => Number(row.qty ?? row.quantity ?? 1) || 1;
  const totalQuantity = (rows) => rows.reduce((sum, row) => sum + quantity(row), 0);
  const totalValue = (rows) => rows.reduce((sum, row) => sum + quantity(row) * (Number(row.price) || 0), 0);
  const entry = (key, current, queued, adding, itemName = '') => {
    const field = transferLimitFields.find((field) => field.key === key);
    const rawLimit = Number(customer[key]);
    const limit = Number.isFinite(rawLimit) && rawLimit > 0 ? rawLimit : null;
    const projected = current + (queued || 0) + (adding || 0);
    return { ...field, itemName, current, queued, adding, projected, limit, violated: limit !== null && projected > limit };
  };
  const entries = [
    entry('consignmentBalanceLimit', Number(summary.totalValue) || 0, totalValue(queuedRows), totalValue(newRows)),
    entry('agedInventoryDaysLimit', Number(summary.maxAgeDays) || 0, null, null),
    entry('inventoryPiecesLimit', Number(summary.totalQuantity) || 0, totalQuantity(queuedRows), totalQuantity(newRows)),
  ];
  const items = new Map();
  for (const row of [...queuedRows, ...newRows]) {
    if (row.itemId) items.set(String(row.itemId), row.item || row.description || `Item ${row.itemId}`);
  }
  for (const [itemId, itemName] of items) {
    const forItem = (rows) => totalQuantity(rows.filter((row) => String(row.itemId) === itemId));
    entries.push(entry('sameItemsLimit', Number(summary.itemCounts?.[itemId]) || 0, forItem(queuedRows), forItem(newRows), itemName));
  }
  return entries;
}
